import PlaceholderImage from 'core/assets/img/profile-tab/history-placeholder-img.webp';
import { BaseImageConfig } from 'core/components/image/BaseImageConfig';
import React, { useEffect, useImperativeHandle, useState } from 'react';

// generated images regex: /.*(user[-_]generated|flux-images).*\.(webp|png|mp4)($|\?)/i;

/* eslint-disable react/jsx-props-no-spreading */
function BaseImage(
	{
		src = null,
		alt = '',
		loading = BaseImageConfig.defaultLoadingType,
		onError = (e) => {
			e.target.onerror = null; // prevents looping
			e.target.src = PlaceholderImage;
			e.target.srcset = '';
		},
		style,
		onLoad,
		...props
	},
	imageRef,
) {
	const [isImageLoaded, setIsImageLoaded] = useState(false);
	const ref = React.useRef(null);

	useImperativeHandle(
		imageRef,
		() => ({
			getImage() {
				return ref.current;
			},
			complete: ref.current?.complete,
		}),
		[ref],
	);

	useEffect(() => {
		if (ref.current) {
			if (ref.current.complete) {
				setIsImageLoaded(true);
			} else if (!ref.current.complete) {
				setIsImageLoaded(false);
			}
		}
	}, [src]);

	const onImageLoadFinish = (e) => {
		setIsImageLoaded(true);
		if (typeof onLoad === 'function') onLoad(e);
	};

	return (
		<img
			ref={ref}
			style={{
				opacity: isImageLoaded || ref.current?.complete ? 1 : 0.4,
				transition: 'opacity 0.1s ease-in-out',
				...style,
			}}
			onLoad={onImageLoadFinish}
			src={src}
			alt={alt}
			loading={loading}
			onError={onError}
			{...props}
		/>
	);
}

/* eslint-enable react/jsx-props-no-spreading */
export default React.forwardRef(BaseImage);
